var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortingTwoArrowsi = function SvgSortingTwoArrowsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454B56",
    fillRule: "evenodd",
    d: "M14.909 17.516v-6.964a.727.727 0 1 1 1.455 0v6.963l2.395-2.395a.728.728 0 0 1 1.029 1.029l-3.636 3.636a.73.73 0 0 1-.492.213h-.035a.728.728 0 0 1-.492-.213l-3.636-3.636a.727.727 0 1 1 1.029-1.029zM8.363 3.999h.018q.098.003.192.031a.7.7 0 0 1 .3.182l3.636 3.636a.73.73 0 0 1-.515 1.242.73.73 0 0 1-.514-.213L9.09 6.482v6.963a.727.727 0 1 1-1.454 0V6.482L5.24 8.877a.727.727 0 1 1-1.028-1.029l3.636-3.636a.73.73 0 0 1 .492-.213z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortingTwoArrowsi);
export default ForwardRef;